export const config = {
  title: 'pawaMatch',
  redirectCookie: 'supportLoginRedirect',
  redirectExpirationTime: '2m',
  itemsPerPage: [10, 25, 50, 100],
  localStorageKeys: {
    OPEN_TABS: 'OpenTabs',
    ADMINS: 'AdminList',
    ISSUES: 'IssueList',
  },
  crossJurisdiction: 'Cross-Jurisdiction',
  channels: [
    'CALL_ME',
    'FACEBOOK_DIRECT',
    'FACEBOOK_COMMENTS',
    'INBOUND_CALL',
    'WHATSAPP',
    'EMAIL',
    'SMS',
    'TWITTER',
    'INSTAGRAM',
  ],
  roles: ['SUPERADMIN', 'ADMIN', 'L1', 'USER', 'REVIEWER', 'COACH'],
  jurisdictions: [
    'UGANDA',
    'NIGERIA',
    'KENYA',
    'KENYA_2',
    'TANZANIA',
    'ZAMBIA',
    'GHANA',
    'CAMEROON',
    'ZIMBABWE',
  ],
  oneDay: 86400000, // 24 * 60 * 60 * 1000
  limitDays: 365 * 10,
  locale: 'en-IE',
  dateTimeParseFormat: 'YYYY-MM-DD HH:mm:ss',
  dateTimeFormat: 'DD/MM/Y HH:mm:ss',
  dxDateTimeFormat: 'dd/MM/yyyy HH:mm:ss',
  dateTimeFormatZoned: 'DD/MM/Y HH:mm:ss z',
  intlDateTimeFormat: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  },
  idFormat: {
    type: 'fixedPoint',
    precision: 0,
  },
  countFormat: {
    type: 'largeNumber',
  },
  financialNumberFormat: {
    type: 'fixedPoint',
    precision: 2,
  },
  successDisplayTime: 4000,
  errorDisplayTime: 5000,
  phonePrefixes: {
    UGANDA: '256',
    NIGERIA: '234',
    KENYA: '254',
    TANZANIA: '255',
    ZAMBIA: '260',
    GHANA: '233',
    CAMEROON: '237',
    ZIMBABWE: '263',
    KENYA_2: '254',
  },
  isoCodes: {
    UGANDA: 'UG',
    NIGERIA: 'NG',
    KENYA: 'KE',
    TANZANIA: 'TZ',
    ZAMBIA: 'ZM',
    GHANA: 'GH',
    CAMEROON: 'CM',
    ZIMBABWE: 'ZW',
    KENYA_2: 'KE2',
  },
  jurisdictionsPageSelection: { list: 'LIST', search: 'SEARCH' },
  statuses: ['NEW', 'OPEN', 'PENDING', 'ESCALATED', 'SOLVED', 'CLOSED'],
  jurisdictionDomain: {
    UGANDA: 'https://www.betpawa.ug',
    NIGERIA: 'https://www.betpawa.ng',
    KENYA: 'https://www.betpawa.co.ke',
    TANZANIA: 'https://www.betpawa.co.tz',
    ZAMBIA: 'https://www.betpawa.co.zm',
    GHANA: 'https://www.betpawa.com.gh',
    CAMEROON: 'https://www.betpawa.cm',
    ZIMBABWE: 'https://www.betpawa.co.zw',
    KENYA_2: 'https://www.bet254.com',
  },
  secure: window.location.protocol === 'https:',
}
